import type { CoverageRule } from '@/shared/types';

/**
 * Builds the screening-option subtitle from a DDS CoverageRule.
 *
 * Returns the pricing-derived string when `rule.pricing` is present
 * (e.g. "6 months Lease Guarantee & 1 month of Deposit Coverage"),
 * otherwise `undefined`. Callers must render nothing when this is
 * undefined — we intentionally do NOT fall back to `rule.description`
 * so that users without pricing permission don't see a stale static
 * subtitle.
 */
export const formatCoverageSubtitle = (rule: CoverageRule): string | undefined => {
  const lgMonths = rule.pricing?.lg_months;
  const sdrMonths = rule.pricing?.sdr_months;

  if (typeof lgMonths === 'number' && typeof sdrMonths === 'number') {
    const lgText = `${lgMonths} ${lgMonths === 1 ? 'month' : 'months'} Lease Guarantee`;
    const sdrText = `${sdrMonths} ${sdrMonths === 1 ? 'month' : 'months'} of Deposit Coverage`;
    return `${lgText} & ${sdrText}`;
  }

  return undefined;
};
